import { jsxs, jsx } from "react/jsx-runtime";
const IconKeyboardDoubleArrowRightSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M6.41 6 5 7.41 9.58 12 5 16.59 6.41 18l6-6z" }),
      /* @__PURE__ */ jsx("path", { d: "m13 6-1.41 1.41L16.17 12l-4.58 4.59L13 18l6-6z" })
    ]
  }
);
export {
  IconKeyboardDoubleArrowRightSvg
};
